import { createSelector } from 'reselect'
import {
  networkGroup,
} from '@nocode-works/template/store/selectors/utils'

import {
  DEFAULT_CURRENCY,
  CURRENCIES,
} from 'settings'

const DEFAULT_OBJECT = {}

const loaded = state => state.user.loaded
const data = state => state.user.data
const accessToken = state => state.user.accessToken

const loggedIn = createSelector(
  data,
  data => data ? true : false
)

const meta = createSelector(
  data,
  data => {
    if(!data) return DEFAULT_OBJECT
    return data.meta || DEFAULT_OBJECT
  }
)

const currency = createSelector(
  meta,
  meta => {
    const currencyName = meta.currency || DEFAULT_CURRENCY
    return CURRENCIES.find(c => c.id == currencyName)
  }
)

const currencyId = createSelector(
  currency,
  currency => currency ? currency.id : DEFAULT_CURRENCY
)

const driveExperience = createSelector(
  meta,
  meta => meta.driveExperience
)

const firstWebsiteTemplate = createSelector(
  meta,
  meta => meta.firstWebsiteTemplate
)

const onboardingCancelled = createSelector(
  meta,
  meta => meta.onboardingCancelled
)

const showNewWebsiteDialog = createSelector(
  meta,
  meta => meta.showNewWebsiteDialog
)

const selectors = {
  loaded,
  data,
  accessToken,
  loggedIn,
  meta,
  currency,
  currencyId,
  driveExperience,
  firstWebsiteTemplate,
  onboardingCancelled,
  showNewWebsiteDialog,
  ...networkGroup('user', [
    'loadStatus',
    'logout',
    'generateAccessToken',
  ])
}

export default selectors
